<template lang="html">
    <div class="legend-container">
        <div
            v-for="(item, index) in items"
            :key="item.label"
            :class="{'disabled': disabledItems.includes(index), 'clickable': itemsClickable}"
            @click="$emit('click', index)"
        >
            <component
                :is="item.custom"
                v-if="item.custom"
                v-bind="item.customProps"
                class="legend-item"
            />
            <div
                v-else
                class="legend-item"
            >
                <component
                    :is="item.icon"
                    v-if="item.icon"
                    :fill="item.iconFillColor"
                    :stroke="item.iconStrokeColor"
                    :class="['icon', item.iconClass]"
                />
                <div
                    v-if="item.iconShape"
                    :class="['icon', 'visual-container', item.iconClass]"
                >
                    <div
                        :class="['visual', item.iconShape, { 'border': item.iconStrokeColor }]"
                        :style="{ backgroundColor: item.iconFillColor, borderColor: item.iconStrokeColor }"
                    />
                </div>
                <div
                    v-if="item.value"
                    class="value"
                >
                    {{ item.value }}
                </div>
                <div class="labels">
                    <div>
                        {{ item.label }}
                    </div>
                    <div>
                        {{ item.sublabel }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Had to name this component FsLegend (Foundry Spatial Legend) as there is a 'legend' html tag
 */

export default {
    name: 'FsLegend',

    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },

        disabledItems: {
            type: Array,
            required: false,
            default: () => [],
        },

        itemsClickable: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>

<style lang="scss">
.legend-container {
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: space-around;
    align-items: center;
    gap: 1rem;

    .legend-item {
        cursor: default;
        display: flex;
        align-items: center;

        > *:not(:last-child){
            margin-right: 1rem;
        }

        .icon {
            height: 2rem;
            width: 2rem;
        }

        .visual-container {
            display: flex;
            align-items: center;
            justify-content: center;

            .solid-line,
            .dashed-line {
                width: 2.5em;
                height: 2px;
                border-width: 2px;
            }

            .solid-line {
                border-style: solid;
            }

            .dashed-line {
                border-style: dashed;
            }

            .circle {
                width: 1em;
                height: 1em;
                border-radius: 1em;

                &.border {
                    border: 2px solid;
                }
            }

            .area{
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 3px;

                &.border {
                    border: 2px solid;
                }
            }
        }
    }

    .disabled .legend-item {
        .icon,
        .visual-container > * {
            opacity: 0.75;
        }

        .labels {
            text-decoration: line-through;
        }
    }

    .clickable .legend-item {
        cursor: pointer;
    }
}
</style>
